import Vue from 'vue'
import VueRouter from 'vue-router'
import VeeValidate from 'vee-validate'

import App from '@main/MainApp.vue'

import BasePage from '@components/BasePage.vue'
import MainPage from '@components/MainPage.vue'
import BoraMain from '@components/bora/BoraMain.vue'
import BoraMainPage from '@components/bora/pages/BoraMainPage.vue'
import PanoramaForm from '@components/bora/PanoramaForm.vue'

import ListPage from '@pages/list/ListPage.vue'
import NewPass from '@pages/NewPass.vue'

import ProductDetailed from '@pages/product/ProductDetailed.vue'

import Dashboard from '@pages/dashboard/Dashboard.vue'
import Settings from '@pages/dashboard/settings/Settings.vue'
import Basket from '@pages/dashboard/basket/Basket.vue'
import Favorites from '@pages/dashboard/favorites/Favorites.vue'
import Wishlist from '@pages/dashboard/wishlist/Wishlist.vue'
import Orders from '@pages/dashboard/orders/Orders.vue'
import Profile from '@pages/dashboard/profile/Profile.vue'

import Checkout from '@pages/checkout/Checkout.vue'
import FlowBasket from '@pages/checkout/FlowBasket.vue'
import FlowData from '@pages/checkout/FlowData.vue'
import FlowFinal from '@pages/checkout/FlowFinal.vue'

import Login from '@components/login/Login.vue'
import CustomPage from '@pages/page/CustomPage.vue'


import {store} from '@main/store.js'
import HsOrder from "@main/components/pages/custom/HsOrder.vue";

Vue.use(VueRouter);
Vue.use(VeeValidate);

var BASE = '/';

window.testEnv = false

var italshop = window.location.host == ('italshop.borakft.'+(window.testEnv?'myitsolver.com':'hu'))

const routes = [
    {
        path:italshop?'/main':'/',
        component: BoraMain,
        children:[
            {
                 path:'',
                 component: BoraMainPage
            },
            {
                 path:'page/:pageId',
                 component: CustomPage
            },
            {
                path:'form/:type',
                component:PanoramaForm
            },
            {
                path:'order',
                component: HsOrder
            },
        ]
    },
    {
       path: italshop?'/':'/webstore',
       component: BasePage,
       children:[
           {
                path:'',
                component:MainPage
           },
           {
                path:'newpass',
                component:NewPass
           },
           {
                path:'list',
                component: ListPage
           },
           {
                path:'page/:pageId',
                component: CustomPage
           },
           {
              path: 'product/:id',
              component: ProductDetailed
          },
          {
              path: 'dashboard',
              component: Dashboard,
              children:[
                  {
                      path:'settings',
                      component: Settings,
                      beforeEnter:checkAuth
                  },
                  {
                      path:'basket',
                      component: Basket
                  },
                  {
                      path:'favorites',
                      component: Favorites
                  },
                  {
                      path:'wishlist',
                      component: Wishlist
                  },
                  {
                      path:'orders',
                      component: Orders,
                      beforeEnter:checkAuth
                  },
                  {
                      path:'profile',
                      component: Profile,
                      beforeEnter:checkAuth
                  }
              ]
          },
          {
              path:'checkout',
              component: Checkout,
              children:[
                  {
                      path:'final',
                      component:FlowFinal
                  },
                  {
                      path:'fail',
                      component:FlowFinal
                  },
                  {
                      path:'basket',
                      component:FlowBasket
                  },
                  {
                      path:'data',
                      component:FlowData
                  }
              ]
          },
       ]
   },
   {
       path:'/login',
       component: Login,
       beforeEnter: function(to, from, next) {
           if (store.getters.isLoggedIn){
               next('/')
           }else{
               next()
           }
        }
   }

]

function checkAuth(to, from, next){
    //TODO: később majd kell ide olyan check is hogy a store init-e és ha nem akkor szerverről csekkelni a usert hogy tuti van-e joga. egyelőre nem prioritás
    if (store.getters.isLoggedIn){
        next()
    }else{
        next('/login')
    }
}

const router = new VueRouter({
    routes: routes,
    base: process.env.NODE_ENV === 'production'?BASE:'/',
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
})

// router.beforeEach((to, from, next) => {
//   if (to.fullPath.startsWith('/webstore/')){
//       next(to.fullPath.replace('/webstore/','/'));
//   }
//   next(to);
// })

Vue.prototype.boraPanorama = boraPanorama;

new Vue({
    el: '#app',
    router:router,
    store: store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/app/main/main.js